import React from 'react';
import { Modal, Button, Row, Col, Badge } from 'react-bootstrap';
import { FaFileAlt, FaTimes } from 'react-icons/fa';
import { format } from 'date-fns';

function ReportDetailsModal({ show, handleClose, report }) {
    if (!report) return null;

    const renderJobcard = (data) => (
        <Row className="gy-3">
            <Col md={6}><div className="text-muted small fw-bold">STATUS</div><Badge bg="primary">{data.status}</Badge></Col>
            <Col md={6}><div className="text-muted small fw-bold">DILUTION</div><div className="fw-bold text-dark">{data.Dilution?.name}</div></Col>
            <Col md={6}><div className="text-muted small fw-bold">REQUESTER</div><div>{data.requester?.username}</div></Col>
            <Col md={6}><div className="text-muted small fw-bold">APPROVER</div><div>{data.approver?.username || 'Pending'}</div></Col>
            <Col md={12}><div className="text-muted small fw-bold">HARDWARE ASSIGNMENT</div><div className="text-info fw-bold">{data.Hardware?.name || 'Unassigned'}</div></Col>
        </Row>
    );

    const renderInventory = (data) => (
        <Row className="gy-3">
            <Col md={6}><div className="text-muted small fw-bold">ITEM NAME</div><div className="fw-bold text-dark">{data.name}</div></Col>
            <Col md={6}><div className="text-muted small fw-bold">STATUS</div><Badge bg="success">{data.status}</Badge></Col>
            <Col md={6}><div className="text-muted small fw-bold">TOTAL QUANTITY</div><div className="fw-bold text-primary">{data.quantity} {data.unit}</div></Col>
            <Col md={6}><div className="text-muted small fw-bold">PORT</div><div>{data.Hardware?.name} (P: {data.hardwarePort})</div></Col>
        </Row>
    );

    const renderConsumption = (data) => (
        <Row className="gy-3">
            <Col md={12}><div className="text-muted small fw-bold">ITEM CONSUMED</div><div className="fw-bold text-dark">{data.Inventory?.name}</div></Col>
            <Col md={6}><div className="text-muted small fw-bold">QUANTITY USED</div><div className="fw-bold text-danger">-{data.quantityUsed} {data.Inventory?.unit}</div></Col>
            <Col md={6}><div className="text-muted small fw-bold">EVENT DATE</div><div>{format(new Date(data.consumptionDate), 'dd/MM/yyyy HH:mm')}</div></Col>
            <Col md={6}><div className="text-muted small fw-bold">TRIGGERING JOBCARD</div><div><Badge bg="light" text="dark" className="border">#{data.jobcardId}</Badge></div></Col>
            <Col md={6}><div className="text-muted small fw-bold">RECIPE</div><div>{data.Formula?.name || 'Custom'}</div></Col>
        </Row>
    );

    const renderDetails = () => {
        switch (report.reportType) {
            case 'Jobcard': return renderJobcard(report.Jobcard);
            case 'Inventory': return renderInventory(report.Inventory);
            case 'Consumption': return renderConsumption(report.Consumption);
            default: return <div>No preview available.</div>;
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered className="um-modal">
            <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #043873 0%, #0a4f9e 100%)', color: 'white' }}>
                <Modal.Title><FaFileAlt className="me-2 text-warning" /> Report Details: #{report.reportId}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4 bg-light">
                
                <h6 className="text-uppercase fw-bold text-primary mb-3">Audit Information</h6>
                <div className="p-4 rounded-4 bg-white shadow-sm border mb-4">
                    {renderDetails()}
                </div>

                <h6 className="text-uppercase fw-bold text-primary mb-3">System Traceability</h6>
                <div className="p-3 rounded-4 bg-white shadow-sm border d-flex justify-content-between align-items-center">
                    <div>
                        <div className="text-muted small fw-bold">GENERATED BY</div>
                        <div className="fw-bold">{report.User?.username}</div>
                    </div>
                    <div className="text-end">
                        <div className="text-muted small fw-bold">TIMESTAMP</div>
                        <div>{format(new Date(report.generatedDate), 'dd/MM/yyyy HH:mm')}</div>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer className="bg-light border-0">
                <Button variant="outline-secondary" className="rounded-pill px-4" onClick={handleClose}>
                    <FaTimes className="me-2"/> Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ReportDetailsModal;